// yaziBoyutu.js — YAZI BOYUTU (− / +) VE TAM YÜKSEKLİK · TEK KAYNAK (30 Eyl 2026)
//
// 🔴 ÖNCESİ (ölçüldü): zoom'u uygulayan fonksiyon 3 yerde ayrı yazılıydı ve "normal
//    boyut" farklıydı — sayfa açılışı (App.js) 13, − + düğmeleri (AdminPanel, Layout)
//    15. Aynı kayıtlı sayı iki büyüklük veriyordu: 13'te sayfa tam boy açılıyor, +'ya
//    basınca 14 olup KÜÇÜLÜYORDU (1,00 → 0,93).
// 🔴 Sayfa CSS `zoom` ile büyütülür; zoom `100vh`/`100vw`yi de ölçekler. "Pencere boyu
//    kadar" çerçeve 13/15'te pencerenin %87'sinde bitiyor, kısa sayfada sol kolonun altı
//    boş kalıyordu (Serkan'ın ekranı, CREWS & OFFICERS). WebKit ve Chrome'da ölçüldü:
//    düz 100vh 0,867 oranında kısa; `calc(100vh / zoom)` tam pencere, taşma yok.
// 🔑 Serkan (30 Eyl 2026): normal boyut 13 ("a") — açılışta herkesin gördüğü boy.
export const FONT_KEY = 'efb_font_size';
export const FONT_DEF = 13;
export const FONT_MIN = 12;
export const FONT_MAX = 24;

// Pencereye oranlı HER ölçü (tam ekran çerçevesi, pencere/panel sınırı "%90 yükseklik"
// gibi) zoom'u geri alır; yoksa büyük yazı boyutunda pencere ekrandan taşar, küçükte kısa
// kalır. `--zoom`u yalnız applyFont yazar. Çıplak `90vh`/`92vw` yazılmaz (nöbetçi test).
export const vh = n => `calc(${n}vh / var(--zoom, 1))`;
export const vw = n => `calc(${n}vw / var(--zoom, 1))`;
export const TAM_YUKSEKLIK = vh(100);
export const TAM_GENISLIK = vw(100);

export const kayitliBoyut = () => parseInt(localStorage.getItem(FONT_KEY) || FONT_DEF, 10);

export function applyFont(size) {
  const oran = String(size / FONT_DEF);
  document.documentElement.style.zoom = oran;
  document.documentElement.style.setProperty('--zoom', oran);
  localStorage.setItem(FONT_KEY, size);
}
